import { CalendarOutlined } from "@ant-design/icons";
import { Col, Divider, Row, Space } from "antd";
import dayjs from "dayjs";

export const DaysSummary = ({
  generatedDates,
  selectedTime,
  timeMode,
}: {
  generatedDates: Date[];
  selectedTime?: dayjs.Dayjs;
  timeMode?: "absolute" | "relative";
}) => {
  const formatTimeDisplay = () => {
    if (!selectedTime) return null;

    if (timeMode === "relative") {
      const hours = selectedTime.hour();
      const minutes = selectedTime.minute();

      if (hours === 0 && minutes === 0) {
        return <span>natychmiast po dodaniu</span>;
      }

      const parts: string[] = [];
      if (hours > 0) {
        parts.push(`${hours} ${hours === 1 ? "godzina" : hours < 5 ? "godziny" : "godzin"}`);
      }
      if (minutes > 0) {
        parts.push(`${minutes} ${minutes === 1 ? "minuta" : minutes < 5 ? "minuty" : "minut"}`);
      }

      return <span>{parts.join(" ")} po dodaniu automatyzacji</span>;
    }

    // Absolute mode - show specific time
    return <span>{`o godz. ${selectedTime.locale("pl").format("LT")}`}</span>;
  };

  return (
    <Row data-ctx="days-summary-container">
      <Divider />
      <h4>Podsumowanie zaplanowanej wysyłki:</h4>
      <Col xs={24} data-ctx="generated-dates">
        {generatedDates.map((myDate) => (
          <Row key={myDate.getTime()}>
            <Col xs={24}>
              <Space size={4}>
                <CalendarOutlined />
                {`${dayjs(myDate).locale("pl").format("dddd")}, ${dayjs(myDate).locale("pl").format("LL")} `}
                {formatTimeDisplay()}
              </Space>
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
};
